let DB_TABLE_ORDER_LIST = 'orders';
let DB_TABLE_LINEUP = 'meny_manage_lineup';
let DB_TABLE_FOOD_DETAILS = 'food_details';
let DB_TABLE_USERS = 'users';

let DB_TABLE_ALL_CATEGORIES = 'stadium_manage_all_categories';
let DB_TABLE_USER_MENU_CATEGORIES = 'user_menu_categories';
let DB_TABLE_USER_MENU_LIST = 'user_menu_list';
let DB_TABLE_ALL_FOOD_DETAILS = 'stadium_manage_all_food_details';
let DB_TABLE_ALL_ORDERS = 'stadium_manage_all_orders';
let DB_TABLE_ALL_SERVICE_REQUESTS = 'meny_manage_all_service_requests';
let DB_TABLE_ADVERTISEMENT_CONFIG = 'meny_manage_advertisement_config';
let DB_TABLE_ADVERTISEMENT_INFO = 'meny_manage_advertisement_info';
let DB_TABLE_RESTAURANT_CONFIG = 'meny_manage_restaurant_config';
let DB_TABLE_USAGE_STATISTICS = 'meny_manage_usage_statistics';
let DB_TABLE_STADIUM_MANAGE_USERS = 'stadium_manage_users';
let DB_TABLE_USER_SETTINGS = 'meny_manage_user_settings';
let DB_TABLE_MENY_TRANSLATION = 'meny_translation';
let DB_STADIUM_MANAGE = 'stadium_manage';
let DB_STADIUM_BILLS = 'stadium_bills';

const RESTAURANT_OPEN_STATE_LOADING = -1;
const RESTAURANT_OPEN_STATE_OPENED = 0;
const RESTAURANT_OPEN_STATE_PREPARING = 1;

export default {
  DB_TABLE_ADVERTISEMENT_CONFIG,
  DB_TABLE_ADVERTISEMENT_INFO,
  DB_TABLE_ALL_FOOD_DETAILS,
  DB_TABLE_ALL_CATEGORIES,
  DB_TABLE_USER_MENU_CATEGORIES,
  DB_TABLE_USER_MENU_LIST,
  DB_TABLE_ALL_ORDERS,
  DB_TABLE_ALL_SERVICE_REQUESTS,
  DB_TABLE_FOOD_DETAILS,
  DB_TABLE_LINEUP,
  DB_TABLE_ORDER_LIST,
  DB_TABLE_RESTAURANT_CONFIG,
  DB_TABLE_USER_SETTINGS,
  DB_TABLE_USERS,
  DB_TABLE_USAGE_STATISTICS,
  DB_TABLE_MENY_TRANSLATION,
  RESTAURANT_OPEN_STATE_LOADING,
  RESTAURANT_OPEN_STATE_OPENED,
  RESTAURANT_OPEN_STATE_PREPARING,
  DB_STADIUM_MANAGE,
  DB_STADIUM_BILLS,
  DB_TABLE_STADIUM_MANAGE_USERS,
};
